var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.responsive
    ? _c(
        "v-app-bar",
        {
          staticClass: "top-app-bar",
          attrs: {
            id: "core-app-bar",
            absolute: "",
            app: "",
            color: "grey darken-4",
            flat: "",
            height: "88"
          }
        },
        [
          _c(
            "v-toolbar-title",
            { staticClass: "font-weight-light align-self-center" },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", icon: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onClick($event)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-view-list")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }